import {LangKeyType} from '../../../provider/locale/translation/type';
import {PostStatusEnum} from '../../../service/posts/posts-types';

// Publication list tabs. Shared so the page, header controls, create button and table card all agree
// on the active-tab values instead of passing raw strings around.
export enum PostsTabEnum {
    Posts = 'posts',
    Stories = 'stories',
    Promotions = 'promotions',
    Events = 'events',
}

export const postStatusOptions: Array<PostStatusEnum> = [
    PostStatusEnum.Draft,
    PostStatusEnum.Planned,
    PostStatusEnum.Sent,
    PostStatusEnum.Deleted,
];

export const postStatusTranslationMap: Record<PostStatusEnum, LangKeyType> = {
    [PostStatusEnum.Draft]: 'POSTS__STATUS__DRAFT',
    [PostStatusEnum.Planned]: 'POSTS__STATUS__PLANNED',
    [PostStatusEnum.Sent]: 'POSTS__STATUS__SENT',
    [PostStatusEnum.Active]: 'POSTS__STATUS__ACTIVE',
    [PostStatusEnum.Deleted]: 'POSTS__STATUS__DELETED',
    [PostStatusEnum.Sending]: 'POSTS__STATUS__IN_PROGRESS',
};
